mutation ReplaceEntityApprover($input: ReplaceEntityApproverInput!) {
  replaceEntityApprover(input: $input) {
    clientMutationId
   approvalHistoryBranchEdge
   {
    node{id}
   }
  }
}
